export const PRIVATE_ROUTE_PREFIXES = [
  // The shared-lesson join page. Reached by a code somebody was handed, so it has no SEO surface,
  // and on an anonymous lesson it becomes the player. Schools clusters already keep crawlers off
  // everything but `/` and the demo request; this is what covers the consumer host, where `/start`
  // is served too.
  '/start',
  '/educators/lessons',
  // Legacy portal path — now redirects to /educators, but keep crawlers off it.
  '/schools/lessons',
  '/schools-mvp',
];

export const PRIVATE_ROUTE_ROBOTS_SETTING = 'noindex,nofollow,nosnippet,noarchive';

export const isPrivateRoute = (path: string) => !!path && PRIVATE_ROUTE_PREFIXES.some(prefix =>
  path.startsWith(prefix),
);

/**
 * The schools product's SEO surface is its public marketing landings plus the
 * demo request they feed: the per-audience landings (`/leaders`, `/advisors`)
 * and `/` (the prefix-free landing path, since Caddy strips the cluster prefix).
 * Everything else is login-walled behind the access gate and gets
 * `PRIVATE_ROUTE_ROBOTS_SETTING` via the robots route middleware (meta tag) and
 * the schoolsSeo nitro plugin (X-Robots-Tag header). `/rewards` stays out while
 * it is gated on `schools-rewards-page-enabled`.
 */
export const SCHOOLS_INDEXABLE_PATHS = ['/', '/leaders', '/advisors', '/request-a-demo'];

export const isSchoolsIndexablePath = (path: string) => SCHOOLS_INDEXABLE_PATHS.includes(path);

export const privateRoutesToSitemapExclude = (prefixes: string[] = PRIVATE_ROUTE_PREFIXES) => {
  return prefixes.flatMap(prefix => [
    prefix,
    `${prefix}/**`,
  ]);
}
